import type {CartItemInterface} from "~/interfaces/CartItemInterface";

export class CartItem {

    id: number;
    variantId: number;
    itemId: number | null = null;
    vibeId: number | null = null;
    attributeLabel: string | null = null;
    attributeValue: string | null = null;
    count: number = 1;

    constructor(id: number, variantId: number, itemId: number | null = null, vibeId: number | null = null) {
        this.id = id;
        this.variantId = variantId;
        this.itemId = itemId;
        this.vibeId = vibeId;
    }

    /**
     *
     * @param obj
     * @return {CartItem}
     */
    static createFromObj(obj: CartItemInterface): CartItem {
        const item = new CartItem(obj.id, obj.variantId, obj.itemId ?? null, obj.vibeId ?? null);
        item.count = obj.count || 1;
        item.attributeLabel = obj.attributeLabel ?? null;
        item.attributeValue = obj.attributeValue ?? null;
        return item;
    }

    toObj(): CartItemInterface {
        return {
            id: this.id,
            variantId: this.variantId,
            itemId: this.itemId,
            vibeId: this.vibeId,
            attributeLabel: this.attributeLabel,
            attributeValue: this.attributeValue,
            count: this.count
        };
    }

}
